import React from 'react';

export default function AnimatedDot({ 
  color = 'green',
  size = 7,
  className = '',
}) {
  const colorMap = {
    green: '#4ade80',
    gold: '#a98a5f',
    cream: '#f1e7d6',
  };
  
  return (
    <span 
      className={`inline-block rounded-full animate-pulse-dot ${className}`}
      style={{ 
        width: `${size}px`, 
        height: `${size}px`,
        backgroundColor: colorMap[color] || colorMap.gold,
      }}
    />
  );
}